var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-grey-light is-4"
  }, [_vm._v(_vm._s(_vm.chapter.author))]), _vm._v(" "), _c('div', {
    staticClass: "content is-medium",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.chapter.essay_preview))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('router-link', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "to": ("/chapter/" + (_vm.chapter.id) + "/essay")
    }
  }, [_vm._v("\n          Continue Reading\n        ")])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title has-text-primary"
  }, [_c('strong', [_vm._v("Commentary")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24dbd76c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EssayPreview.vue
// module id = BH7o
// module chunks = 0